import { NodeView } from 'prosemirror-view'
import Styles from './TrackedChanges.module.scss'
import { Node } from 'prosemirror-model'
import { DATA_TYPE_ATTR } from 'common/Prose/Plugins/TrackChanges/constants'

export class Insertion implements NodeView {
  dom: HTMLSpanElement
  contentDOM: HTMLElement

  constructor(node: Node) {
    this.contentDOM = this.dom = document.createElement('span')
    this.dom.className = Styles.insertion
    this.dom.dataset.uuid = node.attrs.uuid
    this.dom.dataset.type = DATA_TYPE_ATTR
  }
}
